import type { StepDefinition } from "../../../api/content/authoring/stepDecoders";

/** A declared input label in the reader's language, falling back to the source label. */
export function inputLabel(definition: StepDefinition, name: string, language = "en"): string | null {
  const translated = definition.translations?.[language]?.input_labels?.[name];
  if (translated !== undefined && translated !== "") return translated;
  const declared = definition.declared_inputs?.find((input) => input.name === name)?.label;
  return declared === undefined || declared === "" ? null : declared;
}
